import React from "react";
import { Row, Col } from "react-bootstrap"; // Assuming you're using React Bootstrap

import VerticalInputNumberField from "../inputNumberField/VerticalInputNumberField";
import {
  EditIcon,
  DeleteIcon,
  SearchIcon,
  DollarIcon,
  PaymentIcon,
} from "../../../assets/icons/iconsProvider";
import { inventoryConstants, transactionConstants } from "../../../constants";
import {
  PRODUCT_TYPES_ENUMS,
  TRADING_CARD_CATEGORIES_ENUMS,
} from "../../../system/globalEnums";
import SimpleCheckbox from "../checkBox/SimpleCheckbox";
import {
  getShortestSku,
  handleViewEbaySales,
  handleViewTCGPlayer,
  getProductDetailCardTags,
  getFormattedCondition,
} from "../../utility";
import TitleToolTip from "../toolTipComponent/TitleToolTip";
const ReturnChartItem = ({
  product,
  handleInputChange,
  deleteProduct,
  handleViewPriceCharting,
  toggleIframe,
  handleIsDefectiveChange,
}) => {
  return (
    <Row key={product.sku} className="return-chart-div mb-3">
      <Col
        sm={6}
        md={12}
        lg={12}
        xl={6}
        className="m-0 d-flex gap-3 align-items-center p-0"
      >
        <VerticalInputNumberField
          sku={`${product.sku}`}
          placeholder={product.placeholder}
          value={product.editQTY}
          maxValue={product.maxValue}
          onChange={handleInputChange}
        />
        <div className="m-0 d-flex flex-column justify-content-between p-0 w-100">
          <TitleToolTip
            title={product?.itemName}
            childrenClassName="return-product-name"
            isWrapChildren={true}
          >
            {product?.itemName}
          </TitleToolTip>
          <span className="d-flex align-items-center gap-2 user-select-none">
            {product.category === transactionConstants.MISCELLANEOUS_SALE_ITEM
              ? transactionConstants.MISCELLANEOUS
              : product.category}
            {` (${getFormattedCondition(product)}) `}
            {getProductDetailCardTags(
              product.tags?.filter(
                (tag) => tag !== inventoryConstants.CUSTOM_ITEM_TAG
              ),
              product.sku
            )}
          </span>
          <p className="return-product-sku-num">
            #{getShortestSku(product.sku)}
          </p>
        </div>{" "}
      </Col>
      <Col
        sm={6}
        md={12}
        lg={12}
        xl={6}
        className="m-0 d-flex flex-column align-items-end justify-content-center p-0 "
      >
        <div className="d-flex align-items-center justify-content-end w-100 px-0">
          <p className="return-amount-chip">
            $ {product.priceAfterGlobalDiscount}
          </p>
          <div
            onClick={() => deleteProduct(product.sku)}
            className="return-cart-delete-icon"
          >
            <DeleteIcon />
          </div>
        </div>
        <SimpleCheckbox
          name="isDefectiveReturn"
          label="Defective (Don't Restock)"
          labelClassName="text-nowrap"
          onChange={(name, checked) =>
            handleIsDefectiveChange(product.sku, checked)
          }
          isLabelLeft={true}
        />
      </Col>

      {/* Consider moving or reworking this section as needed */}
      {/* {product.category !== transactionConstants.MISCELLANEOUS_SALE_ITEM &&
      product.category !== transactionConstants.MISCELLANEOUS ? (
        product.category === TRADING_CARD_CATEGORIES_ENUMS.POKEMON_CARD ||
        product.category === TRADING_CARD_CATEGORIES_ENUMS.MAGIC_CARD ? (
          <Col className="m-0 d-flex align-items-center gap-3 mt-3 p-0" md={12}>
            <span
              onClick={() => {
                handleViewTCGPlayer({ tcgPlayerUrl: product.tcgPlayerUrl });
              }}
              className="price-charting-text-return cursor-pointer"
            >
              View TcgPlayer
            </span>
          </Col>
        ) : (
          <Col className="m-0 d-flex align-items-center gap-3 mt-3 p-0" md={12}>
            <span
              onClick={() => {
                handleViewPriceCharting(product?.itemName, product?.category);
                toggleIframe();
              }}
              className="price-charting-text-return cursor-pointer"
            >
              Pricecharting
            </span>
            <span
              onClick={() =>
                handleViewEbaySales(
                  product?.itemName,
                  product?.category,
                  product?.subcategory
                )
              }
              className="price-charting-text-return cursor-pointer"
            >
              eBay Sales
            </span>
          </Col>
        )
      ) : (
        ""
      )} */}
    </Row>
  );
};

export default ReturnChartItem;
